


























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter, State } from 'vuex-class'
import { Lantern } from '../../../mj-energy-operator/src/models'
import { Watch } from 'vue-property-decorator'
import { AccidentReason } from '@/types'

@Component
export default class Accident extends Vue {
  accidentReasonId: string | null = null
  accidentReasonDescription: string | null = null

  validation = {
    accidentReasonValidationMessage: '',
    accidentReasonValidationType: ''
  }

  @State('saving', { namespace: 'lanterns' })
  savingReport!: boolean

  @State('useCustomMessage')
  useCustomMessage!: boolean

  @State('customMessage')
  customMessage!: string

  @Getter('lanterns/accidentReasons')
  accidentReasons!: Array<AccidentReason>

  @Getter('lanterns/accidentLantern')
  accidentLantern!: Lantern

  @Action('lanterns/loadAccidentReasons')
  loadAccidentReasons!: () => void

  @Action('lanterns/loadLantern')
  loadLantern!: (id: string) => void

  @Action('lanterns/reportLantern')
  reportLantern!: (data: {}) => Promise<null>

  @Action('lanterns/updateLanternStatus')
  updateLanternStatus!: (id: number) => void

  @Watch('accidentLantern')
  accidentLanternWatch (lantern: Lantern) {
    // move to the map in the case the lanter already has an accident
    if (lantern.hasAccident) {
      this.$router.push({ name: 'Home' })
      this.$buefy.toast.open({
        duration: 4000,
        message: 'That lantern has already been reported'
      })
    }
  }

  async mounted () {
    this.loadAccidentReasons()
    this.loadLantern(
      this.$route.params.id
    )
  }

  resetValidation () {
    this.validation = {
      accidentReasonValidationMessage: '',
      accidentReasonValidationType: ''
    }
  }

  report () {
    if (!this.accidentReasonId) {
      this.validation.accidentReasonValidationType = 'is-danger'
      this.validation.accidentReasonValidationMessage = 'Empty value'
      return
    }
    this.resetValidation()
    this.reportLantern(
      {
        lantern: this.accidentLantern.id,
        reason: this.accidentReasonId,
        comment: this.accidentReasonDescription
      }
    ).then(() => {
      this.updateLanternStatus(this.accidentLantern.gid)
      this.$router.push({ name: 'Home' })
      this.$buefy.toast.open({
        duration: 4000,
        message: this.$t('toasts.reportCreated') as string
      })
      if (this.useCustomMessage && this.customMessage) {
        this.$buefy.toast.open({
          duration: 8000,
          message: this.customMessage
        })
      }
    }).catch(() => {
      this.$buefy.toast.open({
        duration: 4000,
        message: this.$t('toasts.reportCreatedFailed') as string
      })
    })
  }
}
